import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "field"]

  async connect() {
    console.log('🔄 Font Search Controller connecting...');

    try {
      console.log('📡 Fetching /admin/fonts/list.json...');
      const response = await fetch('/admin/fonts/list.json');

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      this.fonts = data.fonts || [];
      console.log('✅ Fonts loaded:', this.fonts.length);

    } catch (error) {
      console.error('❌ Failed to fetch fonts:', error);
      this.fonts = [];
    }
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim();
    const resultsDiv = this.resultsTarget;

    console.log('🔍 Searching for:', query);

    // Helper render function
    const renderList = (items) => {
      if (items.length > 0) {
        resultsDiv.classList.remove('hidden');

        // Batch load the most relevant font previews (top 15)
        items.slice(0, 15).forEach(font => this._loadFont(font.value, '400'));

        const currentValue = this.fieldTarget.value;

        resultsDiv.innerHTML = items.map(font => {
          const isSelected = currentValue === font.value;
          return `
            <button type="button" 
                    class="w-full text-left px-4 py-3 border-b border-beb-line last:border-b-0 transition-colors group flex justify-between items-center ${isSelected ? 'bg-beb-brand-soft' : 'hover:bg-beb-hover'}"
                    data-action="click->font-search#select"
                    data-value="${font.value}"
                    style="font-family: '${font.value}', sans-serif;">
              <div class="flex flex-col">
                <div class="flex items-center gap-2">
                  <span class="text-sm font-medium ${isSelected ? 'text-beb-accent-text' : 'text-beb-fg'} group-hover:text-beb-accent-text transition-colors">${font.label} ${isSelected ? '✓' : ''}</span>
                </div>
                <span class="text-[10px] text-beb-fg-3">The quick brown fox jumps...</span>
              </div>
              <span class="text-[9px] font-bold uppercase tracking-widest text-beb-fg-3 group-hover:text-beb-accent-text transition-all">${font.category || 'font'}</span>
            </button>
          `;
        }).join('');
      } else {
        resultsDiv.classList.add('hidden');
      }
    };

    if (query.length === 0) {
      renderList(this.fonts.slice(0, 100));
      return;
    }

    const results = this.fonts.filter(font =>
      font.label.toLowerCase().includes(query) ||
      font.value.toLowerCase().includes(query)
    ).slice(0, 100);

    renderList(results);
    console.log('✅ Found', results.length, 'fonts');
  }

  select(event) {
    event.preventDefault();
    const fontValue = event.currentTarget.dataset.value;

    // Update both input and hidden field
    this.fieldTarget.value = fontValue;
    this.inputTarget.value = fontValue;
    this.resultsTarget.classList.add('hidden');

    // ⚡ Load font immediately (Redundant but safe)
    this._loadFont(fontValue);

    // CRITICAL FIX: Dispatch event on the VISIBLE input because that is where 
    // data-action="input->block-settings#updateFontFamily" is defined in the HTML
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));

    console.log('✅ Font selected:', fontValue);
  }

  _loadFont(fontName, weights = '400;700') {
    if (!fontName) return;
    const cleanName = fontName.trim();
    const id = `font-${cleanName.replace(/\s+/g, '-').toLowerCase()}`;

    if (document.getElementById(id)) return;

    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${cleanName.replace(/\s+/g, '+')}:wght@${weights}&display=swap&subset=arabic`;

    document.head.appendChild(link);
    console.log(`🔤 Loaded font: ${cleanName} (${weights})`);
  }
}
